import { createV3Queries } from "@query/utils/createV3Queries";
import { complianceEntitiesApi } from "@api";

export const queriesComplianceEntities = createV3Queries(
  "complianceEntitiesApi",
  complianceEntitiesApi,
  {
    createComplianceEntity: queries => ({
      dependencies: () => [queries.listComplianceEntities.queryKeyBase]
    }),
    updateComplianceEntity: queries => ({
      dependencies: () => [
        queries.listComplianceEntities.queryKeyBase,
        queries.getComplianceEntity.queryKeyBase
      ]
    }),
    verifyComplianceEntity: queries => ({
      dependencies: () => [queries.getComplianceEntity.queryKeyBase]
    })
  }
);
